// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ClientProvider } from './context/ClientContext'; // Importa el ClientProvider
import { ProgressProvider } from './context/ProgressContext';
import MobileLayout from './layouts/MobileLayout';
import MaintenanceScreen from './components/MaintenanceScreen';

// Importa tus layouts y páginas
import AuthLayout from './layouts/AuthLayout';
import PortalLayout from './layouts/PortalLayout';
import LoginPage from './pages/LoginPage';
import RequiredPasswordChangePage from './pages/RequiredPasswordChangePage';
import HomePage from './pages/HomePage';
import ProfilePage from './pages/ProfilePage'; // Importa ProfilePage
import ProtectedRoute from './components/ProtectedRoute';
import MobileProtectedRoute from './components/MobileProtectedRoute';
import RequestsPage from './pages/RequestsPage';
import PresetRequestsPage from './pages/PresetRequestsPage';
import MobileDocumentsPage from './pages/MobileDocumentsPage';
import MobileCommerceSignaturePage from './pages/MobileCommerceSignaturePage';
import MobileErrorPage from './pages/MobileErrorPage';
import MobileOnboardingPage from './pages/MobileOnboardingPage';
import CollectionPage from './pages/CollectionPage';
import ZReportsPage from './pages/ZReportsPage';
import ObservationPage from './pages/ObservationPage';
import MobileCustomerFlowPage from './pages/MobileCustomerFlowPage';
import MobileIdentityCallbackPage from './pages/MobileIdentityCallbackPage';
import ApprovedRequestsPage from './pages/ApprovedRequestsPage';
import ComersOriginationsBoardPage from './pages/ComersOriginationsBoardPage';
import IssuedLoansPage from './pages/IssuedLoansPage';

function App() {
  // Verificar si el modo de mantenimiento está activado
  const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';

  // Si está en modo mantenimiento, mostrar solo la pantalla de mantenimiento
  if (isMaintenanceMode) {
    return <MaintenanceScreen />;
  }

  return (
    <Router>
      <Routes>
        {/* Rutas de autenticación */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/cambiar-contrasena" element={<RequiredPasswordChangePage />} />
        </Route>

        {/* Rutas protegidas dentro del Portal */}
        <Route
          element={
            <ProtectedRoute>
              <ClientProvider>
                <ProgressProvider>
                  <PortalLayout />
                </ProgressProvider>
              </ClientProvider>
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<HomePage />} />
          <Route path="/clientes/:dni" element={<ProfilePage />} />
          <Route path="/creditos" element={<IssuedLoansPage />} />
          <Route path="/solicitudes" element={<RequestsPage />} />
          <Route path="/solicitudes/:presetKey" element={<PresetRequestsPage />} />
          <Route path="/solicitudes-aprobadas" element={<ApprovedRequestsPage />} />
          <Route path="/tablero-originacion" element={<ComersOriginationsBoardPage />} />
          <Route 
            path="/cobros" 
            element={
              <ProtectedRoute type="collections">
                <CollectionPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/reportes-z" 
            element={
              <ProtectedRoute type="zreports">
                <ZReportsPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/observaciones" 
            element={
              <ProtectedRoute type="observations">
                <ObservationPage />
              </ProtectedRoute>
            } 
          />
        </Route>

        {/* Rutas móviles sin layout completo */}
        <Route element={<MobileLayout />}>
          {/* Rutas públicas (sin token) */}
          <Route path="/m/error/:type" element={<MobileErrorPage />} />
          <Route path="/m/identity-callback" element={<MobileIdentityCallbackPage />} />
          
          {/* Rutas protegidas con token */}
          <Route 
            path="/m/docs/:token" 
            element={
              <MobileProtectedRoute>
                <MobileDocumentsPage />
              </MobileProtectedRoute>
            } 
          />
          <Route 
            path="/m/onboarding/:token" 
            element={
              <MobileProtectedRoute>
                <MobileOnboardingPage />
              </MobileProtectedRoute>
            } 
          />
          <Route 
            path="/m/docs/:token/requests" 
            element={
              <MobileProtectedRoute>
                <MobileDocumentsPage />
              </MobileProtectedRoute>
            } 
          />
          <Route 
            path="/m/onboarding/:token/flow" 
            element={
              <MobileProtectedRoute>
                <MobileCustomerFlowPage />
              </MobileProtectedRoute>
            } 
          />
          <Route
            path="/m/signature/:token"
            element={
              <MobileProtectedRoute>
                <MobileCommerceSignaturePage />
              </MobileProtectedRoute>
            }
          />
        </Route>
      </Routes>
    </Router>
  );  
}

export default App;
